module.exports = __webpack_public_path__ + "static/media/Ankitha-B.8ff5fd7d.svg";